{
  "nl": {
    "contact": {
      "actions": {
        "accept": "Akkoord",
        "add": "Nieuw Contact",
        "add_type": "Voeg {type} toe",
        "backInspirationLists": "Terug naar Inspiratie Lijsten",
        "cancelNew": "Annuleer",
        "deactivateEmployee": "Deactiveer",
        "deleteCustomer": "Verwijder klant...",
        "deleteEmployee": "Verwijder teamlid...",
        "deleteLead": "Lead verwijderen...",
        "deletePartner": "Verwijder partner...",
        "delete_contact": "Verwijderen",
        "edit": "Bewerken",
        "impersonate": "Impersoneer",
        "impersonateStart": "Ga door het oranje portaal om de wereld van {name} te verkennen.",
        "impersonateStop": "Stop impersonatie",
        "invite": "Verstuur uitnodiging",
        "newTicket": "Nieuw Gesprek",
        "reactivateEmployee": "Reactiveer",
        "resendInvitationEmail": "Stuur uitnodigingsemail opnieuw",
        "searchContact": "Zoek Contact",
        "searchCustomer": "Zoek Klant",
        "searchEmployee": "Zoek Teamlid",
        "selectAll": "Selecteer alle {total} contacten",
        "selectOption": "Selecteer optie",
        "setProfilePicture": "Stel profielfoto in",
        "showall": "Toon alle",
        "unSelectAll": "Verwijder selectie."
      },
      "attributes": {
        "language": "Taal",
        "timezone": "Tijdzone",
        "title": "Titel"
      },
      "labels": {
        "address": "Adres",
        "all": "Alle contacten",
        "back_to_overview": "Terug naar het overzicht",
        "cannot_delete": "Kan deze gebruiker niet verwijderen (integratie)",
        "company": "Bedrijf",
        "company_all": "Elk bedrijf",
        "contact_status": {
          "active": "Actief",
          "added": "Nog niet uitgenodigd",
          "all": "Alle statussen",
          "blocked": "Gedeactiveerd",
          "invited": "Uitgenodigd",
          "status": "Status"
        },
        "contact_type": "Type",
        "customer": "Klant",
        "customers": "Klanten",
        "employee": "Teamleden",
        "export_contacts": "Contacten exporteren",
        "general": "Algemeen",
        "impersonateInactiveProfile": "Deze geweldige persoon is nog niet actief. Activeer de klant eerst.",
        "invite": "Ja, nodig contacten uit",
        "inviteProfileFirstCustomer": "Nodig eerst de klant uit om een bericht te sturen, te impersoneren of nieuwe uitnodigingsemail uit te sturen",
        "inviteProfileFirstPartner": "Nodig eerst de partner uit om te impersoneren of nieuwe uitnodigingsemail uit te sturen",
        "last_login": "Laatste aanmelding",
        "last_seen": "laatst gezien",
        "last_seen_not_seen_yet": "nog niet gezien",
        "lead": "Lead",
        "name": "Naam",
        "name_or_email_address": "Naam of e-mailadres",
        "name_or_email_address_phone": "Naam, e-mailadres of telefoon",
        "noContacts": "Geen contacten",
        "no_contacts": "Geen contacten te exporteren",
        "no_contacts_results": "Deze zoekopdracht heeft geen resultaten. Probeer andere filters uit om de juiste persoon te vinden.",
        "no_contacts_results_subtitle": "Deze zoekopdracht heeft geen resultaten. Probeer andere filters uit om de juiste persoon te vinden.",
        "no_contacts_results_title": "Geen contacten gevonden",
        "number_contacts": "Geen contacten | 1 contact | {count} contacten",
        "other": "Andere",
        "partner": "Partner",
        "partners": "Partners",
        "project": "Project",
        "secondary_contact": "Tweede contactpersoon",
        "selectOne": "Selecteer minimaal 1 contactpersoon",
        "selectProjectForImpersonation": "Voor welk project wil je {customer_name} impersoneren?",
        "selected": "{selected} contactpersoon geselecteerd. | {selected} contactpersonen geselecteerd.",
        "sorting": {
          "last_name": "Naam",
          "session_started_at": "Laatste aanmelding",
          "status": "Status"
        },
        "totalSelected": "Alle {total} contacten zijn geselecteerd.",
        "units": "Units"
      },
      "navigation": {
        "backToContacts": "Terug naar contacten"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Op naam of e-mailadres"
      },
      "validation": {
        "emailTaken": "Emailadres is al in gebruik",
        "mustBeEmailAddress": "Moet een emailadres zijn",
        "requireEmailAddress": "Emailadres vereist"
      }
    }
  }
}
